import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MenuService } from 'src/app/components/menu/service/menu.service';
import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';

import {
  mapAcxTradeOperationToView,
  OperationAcxTradeDetailsView,
} from '../shared/operation-acx-trade-details.utils';

@Component({
  standalone: false,
  selector: 'app-operation-acx-trade-details-drawer',
  templateUrl: './operation-acx-trade-details-drawer.component.html',
  styleUrls: ['./operation-acx-trade-details-drawer.component.scss'],
})
export class OperationAcxTradeDetailsDrawerComponent implements OnChanges {
  @Input() open = false;
  @Input() operation: CarbonOperation | null = null;
  @Output() openChange = new EventEmitter<boolean>();

  details: OperationAcxTradeDetailsView | null = null;

  constructor(private readonly menuService: MenuService) {}

  get acxPlatformUrl(): string {
    return this.menuService.getAcxPlataformRedirectUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['open'] || changes['operation']) && this.open && this.operation) {
      this.details = mapAcxTradeOperationToView(this.operation);
    }

    if (changes['open'] && !this.open) {
      this.details = null;
    }
  }

  onAcxLinkClick(event: MouseEvent): void {
    if (!this.acxPlatformUrl) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    this.menuService.openAcxPlatform();
  }

  close(): void {
    this.open = false;
    this.openChange.emit(false);
  }
}
